import SupplementalMaterialsButton from '../../../../common/components/documentViewer/supplementalMaterialsButton';
import { IOrderViewerMainStore } from '../../typing/stores';
import { inject, observer } from 'mobx-react';

export default inject((stores: IOrderViewerMainStore) => ({
	supplementalMaterialsStatus: stores.orderViewerStore.supplementalMaterialsStatus,
	supplementalMaterialsLinks:
		stores.orderViewerStore.viewModel.headerModel.supplementalMaterialViewModel.supplementalMaterialsLinks,
	supplementalMaterialsCount:
		stores.orderViewerStore.viewModel.headerModel.supplementalMaterialViewModel.supplementalMaterialsCount,
	orderId: stores.orderViewerStore.viewModel.orderId,
	apiService: stores.api.orderViewerApiService,
	collectionId: stores.orderViewerStore.viewModel.headerModel.supplementalMaterialViewModel.collectionId,
	orderViewLogonUrl: stores.orderViewerStore.viewModel.orderLogonViewerUrl.logonUrl,
	renderAsDropdownButton: false,
	setStatus: stores.orderViewerStore.setSupplementalMaterialsStatus
}))(observer(SupplementalMaterialsButton));
